import * as React from "react";
import { Switch } from "@/components/ui";
import { cn } from "@/lib/utils";
import { VideoProject } from "@/services/bedrock";

export type EditorVideoProjectField =
  | "message"
  | "isAutoPost"
  | "preferredPostDate"
  | "allowPlayerHashtags"
  | "allowShortLink"
  | "allowCompliance"
  | "socialNetworkIds";

interface Props {
  videoProject: VideoProject;
  disabled: boolean;
  showHashtagToggle: boolean;
  /** The coach adds the compliance disclaimer automatically, so it's always on. */
  disclaimerRequired: boolean;
  onChangeField: (field: EditorVideoProjectField, value: any) => void;
}

export const EditorCaptionSettings: React.FC<Props> = ({
  videoProject,
  disabled,
  showHashtagToggle,
  disclaimerRequired,
  onChangeField,
}) => {
  const labelClassName = cn("text-sm font-semibold text-slate-800", disabled ? "cursor-default" : "cursor-pointer");

  return (
    <div className="flex flex-col gap-4 border-l-2 border-slate-200 ml-2 pl-4">
      {showHashtagToggle && (
        <div className="flex flex-row items-center gap-3">
          <Switch
            id="allowHashtags"
            disabled={disabled}
            checked={!!videoProject.allowPlayerHashtags}
            onCheckedChange={checked => onChangeField("allowPlayerHashtags", checked)}
          />
          <label htmlFor="allowHashtags" className={labelClassName}>
            Include player's hashtags
          </label>
        </div>
      )}

      <div className="flex flex-row items-center gap-3">
        <Switch
          id="allowShortLink"
          disabled={disabled}
          checked={!!videoProject.allowShortLink}
          onCheckedChange={checked => onChangeField("allowShortLink", checked)}
        />
        <label htmlFor="allowShortLink" className={labelClassName}>
          Include player's short link
        </label>
      </div>

      <div className="flex flex-row items-center gap-3">
        <Switch
          id="allowComplianceDisclaimer"
          disabled={disabled || disclaimerRequired}
          checked={!!videoProject.allowCompliance || disclaimerRequired}
          onCheckedChange={checked => onChangeField("allowCompliance", checked)}
        />
        <label htmlFor="allowComplianceDisclaimer" className={labelClassName}>
          Include Compliance Disclaimer
        </label>
      </div>
    </div>
  );
};
